// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28qhA","inner":"Footer_inner__11AnD","nextIcon":"Footer_nextIcon__2Woes","innerLeft":"Footer_innerLeft__1cEZ_"};